var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("SeaExport.PreviewOfBookingFileParsing"),
        "custom-class": "intelligent-booking-result-dialog",
        visible: _vm.innerVisible,
        fullscreen: "",
        modal: false,
        "append-to-body": true,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-tab",
          staticStyle: {
            "flex-grow": "1",
            display: "flex",
            "flex-direction": "column",
            overflow: "auto"
          }
        },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { "margin-top": "8px" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_identifyTheResult"),
                    name: "identifyResult"
                  }
                },
                [
                  _c(
                    "cargo-left-right-resize",
                    {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        "left-style": { "min-width": "550px", width: "50%" },
                        "right-style": { "min-width": "550px", width: "50%" }
                      }
                    },
                    [
                      _c("template", { slot: "left" }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "100%",
                              height: "100%",
                              overflow: "auto"
                            }
                          },
                          [
                            _vm.visible
                              ? _c("image-preview-by", {
                                  attrs: {
                                    details: _vm.details,
                                    "cur-focus": _vm.curFocus
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _c("template", { slot: "right" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "16px",
                              "padding-left": "20px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_identifyTheResult2")
                              )
                            )
                          ]
                        ),
                        _vm.details.identificationType === _vm.SENDING_2.code
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "100%",
                                  height: "100%",
                                  overflow: "auto"
                                }
                              },
                              [
                                _vm.visible
                                  ? _c("result-form-bill-by", {
                                      ref: "resultForm1",
                                      attrs: { details: _vm.details },
                                      on: {
                                        fieldFocus: function(val) {
                                          return (_vm.curFocus = val)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ContrastingSystem"),
                    name: "ContrastingSystem"
                  }
                },
                [
                  _c(
                    "cargo-left-right-resize",
                    {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        "left-style": { "min-width": "550px", width: "50%" },
                        "right-style": { "min-width": "550px", width: "50%" }
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "left" },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "16px",
                                "padding-left": "20px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_identifyTheResult2")
                                )
                              )
                            ]
                          ),
                          _vm.visible
                            ? _c("result-form-bill-by", {
                                ref: "resultForm2",
                                attrs: {
                                  "job-uuid": _vm.comparisonDetail.jobUuid,
                                  details: _vm.comparisonDetail
                                },
                                on: {
                                  fieldFocus: function(val) {
                                    return (_vm.curFocus = val)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "right" },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "16px",
                                "padding-left": "20px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_SystemResult"))
                              )
                            ]
                          ),
                          _vm.visible
                            ? _c("result-form-bill-by", {
                                ref: "resultForm3",
                                attrs: {
                                  "show-job": true,
                                  "job-uuid": _vm.comparisonDetail.jobUuid,
                                  details: _vm.comparisonDetail
                                },
                                on: {
                                  fieldFocus: function(val) {
                                    return (_vm.curFocus = val)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.details.status === 3
        ? _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { no: "1" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("Message.Close")))]
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.activeTabName === "identifyResult"
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "2", type: "primary" },
                      on: { click: _vm.saveHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  )
                : _vm._e(),
              _vm.activeTabName === "ContrastingSystem"
                ? _c(
                    "el-button",
                    { attrs: { no: "3" }, on: { click: _vm.handleSave } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SaveBillData")))]
                  )
                : _vm._e(),
              _vm.activeTabName === "ContrastingSystem"
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "4", type: "primary" },
                      on: { click: _vm.coveringBillHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SaveBill2")))]
                  )
                : _vm._e(),
              _c(
                "el-button",
                { attrs: { no: "5" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
              )
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }